import { Link, useLocation } from 'react-router-dom'
import { cn } from '../../../lib/cn.ts'
import type { NavItem } from '../types.ts'

interface SidebarNavItemProps {
  item: NavItem
  to: string
  isCollapsed: boolean
}

export function SidebarNavItem({ item, to, isCollapsed }: SidebarNavItemProps) {
  const location = useLocation()
  const isActive = location.pathname === to || location.pathname.startsWith(`${to}/`)
  const Icon = item.icon

  return (
    <Link
      to={to}
      className={cn(
        'group flex w-full items-center rounded-md px-2 py-2.5 text-sm font-medium',
        'text-sidebar-text outline-none transition-colors duration-200',
        'focus-visible:ring-2 focus-visible:ring-ring focus-visible:ring-offset-2 focus-visible:ring-offset-background',
        isActive
          ? 'bg-sidebar-active-bg text-sidebar-active-text'
          : 'hover:bg-sidebar-hover-bg hover:text-sidebar-active-text',
      )}
      title={isCollapsed ? item.label : undefined}
    >
      <Icon className="h-[18px] w-[18px] shrink-0" aria-hidden="true" />
      <span
        className={cn(
          'overflow-hidden whitespace-nowrap transition-all duration-300 ease-in-out',
          isCollapsed ? 'ml-0 max-w-0 opacity-0' : 'ml-3 max-w-[180px] opacity-100',
        )}
      >
        {item.label}
      </span>
    </Link>
  )
}
